export const changePageTitle = (name) => {
  const titleElement = document.querySelector('title');
  titleElement.innerHTML = `${name} | ${titleElement.text}`;
};
